import api from '../../api/apiClient';

/** A file attached to a submission, as resolved by the API. */
export interface SubmissionDocument {
  id: number;
  name: string;
  url: string;
}

interface BaseSubmission {
  id: number;
  email: string;
  contact: string;
  whatsapp: string;
  documents: SubmissionDocument[];
  status: string;
  submitted_at: string | null;
}

export interface SalesEnquiry extends BaseSubmission {
  name: string;
  enquiry: string;
  contact_type: string;
  preferred_time: string | null;
}

export interface AllianceRequest extends BaseSubmission {
  company_name: string;
  poc: string;
  website: string | null;
  business_type: string;
  description: string;
  office_address: string;
}

export interface WebsiteFeedback extends BaseSubmission {
  name: string;
  feedback_type: string;
  feedback: string;
}

/** The triage states offered in the UI. Stored as free text by the API. */
export const SUBMISSION_STATUSES = ['New', 'In Progress', 'Closed'] as const;

export type SubmissionType = 'enquiries' | 'alliances' | 'feedback';

const unwrap = async <T>(promise: Promise<{ data: { data: T } }>): Promise<T> => {
  const res = await promise;
  return res.data.data;
};

export function getSalesEnquiries(): Promise<SalesEnquiry[]> {
  return unwrap(api.get('/api/contact-submissions/enquiries'));
}

export function getAllianceRequests(): Promise<AllianceRequest[]> {
  return unwrap(api.get('/api/contact-submissions/alliances'));
}

export function getWebsiteFeedback(): Promise<WebsiteFeedback[]> {
  return unwrap(api.get('/api/contact-submissions/feedback'));
}

export async function updateSubmissionStatus(
  type: SubmissionType,
  id: number,
  status: string
): Promise<void> {
  await api.patch(`/api/contact-submissions/${type}/${id}/status`, { status });
}
